<form [formGroup]="scholarshipForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header">
        {{type}} Scholarship
        <div class="absolute right-2">
            <button (click)="handleCloseDialog()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content" style="margin-top: -15px;">
        <!-- Scholarship Code and Name -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Scholarship Code</label>
                <input pInputText formControlName="scholarship_code" placeholder="Enter Scholarship Code" />
                <small *ngIf="scholarshipForm.get('scholarship_code')?.invalid && isSubmitted" class="p-error">
                    Scholarship Code is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Scholarship Name</label>
                <input pInputText formControlName="name" placeholder="Enter Scholarship Name" />
                <small *ngIf="scholarshipForm.get('name')?.invalid && isSubmitted" class="p-error">
                    Scholarship Name is required
                </small>
            </div>
        </div>

        <!-- Description -->
        <div class="field">
            <label>Description</label>
            <textarea pTextarea formControlName="description" placeholder="Enter Description" rows="3"></textarea>
        </div>

        <!-- Type and Eligibility Criteria -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Type</label>
                <p-select [options]="typeOptions" formControlName="type" placeholder="Select Type"></p-select>
                <small *ngIf="scholarshipForm.get('type')?.invalid && isSubmitted" class="p-error">
                    Type is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Currency</label>
                <p-select [options]="currencyOptions" formControlName="currency" placeholder="Select Currency"></p-select>
                <small *ngIf="scholarshipForm.get('currency')?.invalid && isSubmitted" class="p-error">
                    Currency is required
                </small>
            </div>
        </div>

        <!-- Eligibility Criteria -->
        <div class="field">
            <label class="requiredValue">Eligibility Criteria</label>
            <textarea pTextarea formControlName="eligibility_criteria" placeholder="Enter Eligibility Criteria" rows="2"></textarea>
            <small *ngIf="scholarshipForm.get('eligibility_criteria')?.invalid && isSubmitted" class="p-error">
                Eligibility Criteria is required
            </small>
        </div>

        <!-- Amount Type and Value -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Amount Type</label>
                <p-select [options]="amountTypeOptions" formControlName="amount_type" placeholder="Select Amount Type"></p-select>
                <small *ngIf="scholarshipForm.get('amount_type')?.invalid && isSubmitted" class="p-error">
                    Amount Type is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Amount Value</label>
                <input pInputText formControlName="amount_value" placeholder="Enter Amount Value" type="number" />
                <small *ngIf="scholarshipForm.get('amount_value')?.invalid && isSubmitted" class="p-error">
                    Amount Value is required and must be greater than 0
                </small>
            </div>
        </div>

        <!-- Max Beneficiaries and Renewable -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Max Beneficiaries</label>
                <input pInputText formControlName="max_beneficiaries" placeholder="Enter Max Beneficiaries" type="number" />
                <small *ngIf="scholarshipForm.get('max_beneficiaries')?.invalid && isSubmitted" class="p-error">
                    Max Beneficiaries is required and must be at least 1
                </small>
            </div>

            <div class="field">
                <label>Renewable</label>
                <div class="flex items-center mt-2">
                    <p-checkbox formControlName="renewable" [binary]="true"></p-checkbox>
                    <span class="ml-2">Is this scholarship renewable?</span>
                </div>
            </div>
        </div>

        <!-- Start and End Date -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Start Date</label>
                <p-calendar formControlName="start_date" dateFormat="yy-mm-dd"
                    placeholder="Select Start Date"
                    appendTo="body"
                    class="w-full"
                    [style]="{ width: '100%' }"></p-calendar>
                <small *ngIf="scholarshipForm.get('start_date')?.invalid && isSubmitted" class="p-error">
                    Start Date is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">End Date</label>
                <p-calendar formControlName="end_date" 
                    class="w-full"
                    appendTo="body"
                    dateFormat="yy-mm-dd"
                    [style]="{ width: '100%' }"
                    placeholder="Select End Date"></p-calendar>
                <small *ngIf="scholarshipForm.get('end_date')?.invalid && isSubmitted" class="p-error">
                    End Date is required
                </small>
            </div>
        </div>

        <!-- Status -->
        <div class="field">
            <label class="requiredValue">Status</label>
            <p-select [options]="statusOptions" formControlName="status" placeholder="Select Status"></p-select>
            <small *ngIf="scholarshipForm.get('status')?.invalid && isSubmitted" class="p-error">
                Status is required
            </small>
        </div>

        <!-- Action buttons -->
        <div class="flex justify-end gap-2 mt-8">
            <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
                (click)="onSubmit()"></p-button>
        </div>
    </div>
</form>